var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('Title')],1),_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }